module.exports = __webpack_public_path__ + "static/media/campus1.7346efd2.png";